/**
 * Сторінка логіну
 * @component LoginPage
 * @file LoginPage.tsx
 * @path frontend/src/pages/LoginPage.tsx
 */

import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigation } from '../../hooks/useNavigation';
import { BusinessTypes } from '../../utils/businessUtils';
import { PRIVATE_ROUTES } from '../../constants/routes';
import { loginWithGoogle } from '../../services/authService';
import './style.css';

const LoginPage: React.FC = () => {
  const { login } = useAuth();
  const { navigateTo } = useNavigation();
  const [isLoading, setIsLoading] = useState(false);
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);

  const handleLogin = async (): Promise<void> => {
    setIsLoading(true);
    
    try {
      // Тимчасовий мок-логін
      const mockUser = {
        id: '1',
        email: 'user@example.com',
        password: 'mock-password',
        fullName: 'John Doe',
        role: 'client' as const,
        businessType: BusinessTypes.SALON,
        language: 'en' as const,
        phoneNumber: '+380123456789'
      };
      
      login(mockUser);
      navigateTo(PRIVATE_ROUTES.HOME);
    } catch (error) {
      console.error('Помилка логіну:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async (): Promise<void> => {
    setIsGoogleLoading(true);
    try {
      // Simple mock call (real flow handled in modal); here we just fallback
      const data = await loginWithGoogle('mock-id-token');
      if (data.user) {
        login(data.user);
        navigateTo(PRIVATE_ROUTES.HOME);
      }
    } catch (error) {
      console.error('Google login error:', error);
    } finally {
      setIsGoogleLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1 className="login-title">Вхід в систему</h1>
          <button 
            className="login-button primary"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? 'Вхід...' : 'Демо вхід'}
          </button>

          <div style={{ marginTop: '12px' }}>
            <button
              className="login-button"
              onClick={handleGoogleLogin}
              disabled={isGoogleLoading}
            >
              {isGoogleLoading ? 'Google...' : 'Увійти з Google'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;